import { useEffect, useState } from 'react';
import { MdDeleteForever } from 'react-icons/md';

export const BASE_URL_IMG = process.env.NODE_ENV === 'development'
  ? process.env.REACT_APP_API_DEV_IMG_BASE_URL
  : process.env.REACT_APP_API_PROD_IMG_BASE_URL;

const CustomHomeModalImageUploader = ({ setFieldValue, customModalHomeFormMessages, values }) => {
  const [imagePreview, setImagePreview] = useState('');

  useEffect(() => {
    if (values && typeof values.img === 'string' && values.img !== '') {
      const url = `${BASE_URL_IMG}${values.img}`;
      setImagePreview(url || values.img);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        setFieldValue('img', file);
        setFieldValue('active', true);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        setFieldValue('img', file);
        setFieldValue('active', true);
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const deleteImg = async () => {
    setImagePreview('');
    setFieldValue('img', '');
    setFieldValue('active', false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div>
      <div
        style={{
          border: '2px dashed #ccc',
          padding: '20px',
          textAlign: 'center',
          position: 'relative'
        }}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
      >
        <input
          type='file'
          accept='image/*'
          style={{ display: 'none' }}
          id='fileInput'
          onChange={handleImageChange}
        />
        <label htmlFor='fileInput' className='img-uploader-box'>
          {imagePreview
            ? (
              <div>
                <img src={imagePreview} alt='Preview' />
                <MdDeleteForever onClick={deleteImg} className='delete-icon' />
              </div>
            )
            : (
              <p style={{ margin: '0', color: 'black' }}>
                {customModalHomeFormMessages.custom_home_modal_admin_img_loader_info}
              </p>
            )}
        </label>
      </div>
    </div>
  );
};

export default CustomHomeModalImageUploader;
